import React, { useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { superAxiosRequest } from 'axiosApi'
import Stores from 'Stores'
import OpenHeader from '../OpenHeader'
import style from './TestResults.module.scss'
import TestResult from './TestResult/TestResult'
import { ReactComponent as EmptyData } from 'components/ContentBox/img/empty.svg'
import HeaderContentBox from '../HeaderContentBox'
import useLocalization from 'hooks/useLocalization'
import asideModalStore from 'Stores/asideModalStore'
import AddingPersonalTestResultsModal from './TestResultsModals/AddingPersonalTestResultsModal'
import { observer } from 'mobx-react'
import swal from 'sweetalert'
import { timeConverter } from 'components/ContentBox/Online-schedule/components/functions'
import { localisationMaster } from 'Localisation/Localisation'

const TestResults = (props) => {
  const [testResults, setTestResults] = useState([])
  const [open, setOpen] = useState(false)
  const [categories, setCategories] = useState([])

  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'group_tests',
    dict: {
      save: 'Save',
      edit: 'Edit',
      delete: 'Delete',
      adding_personal_test_results: 'Adding personal test results',
      tests: 'Tests',
      general: 'General',
      total: 'Total',
      yr: 'ж.',
    },
  })

  const menu = [
    { name: translate?.edit, action: 'edit' },
    { name: translate?.delete, action: 'delete' },
  ]
  let ms = (isFinished) => {
    return {
      modalBodyComponent: () => (
        <AddingPersonalTestResultsModal
          isSmallForm={isFinished}
          students={(props?.students || []).map((item) => ({
            ...item,
            full_name: Stores.transliterate(item.full_name),
            father_name: Stores.transliterate(item.father_name),
            last_name: Stores.transliterate(item.last_name),
          }))}
          categories={categories}
          tests={[...new Set(props?.tests?.map((item) => item?.test) || [])]}
        />
      ),
      data: 'json',
      button: translate?.save,
      link: 'groups/interim_result_tests',
      title: translate?.adding_personal_test_results,
      type: 'groupTestResult',
      onBeforeSubmit: onBeforeUpdate,
      onSubmitSuccess: (data) => {
        setTestResults([...data?.interim, ...data?.test_results])
      },
      isResponsive: true,
      valid: {
        category: 'required',
        student: 'required',
        test: 'required',
        test_scores: 'required',
      },
    }
  }

  const onBeforeUpdate = (formData) => {
    const dataToSend = {
      ...formData,
    }

    if (!dataToSend?.description) delete dataToSend.description

    return dataToSend
  }

  const onAfterFinishedTestUpdate = (data) => {
    setTestResults(
      testResults.map((result) => (result?.id === data?.id ? data : result)),
    )
  }

  const addTest = () => {
    asideModalStore.activity(ms(false), {
      group: +props?.gid,
    })
  }

  const actions = (action, e, item, isFinished) => {
    switch (action) {
      case 'edit':
        const initialMs = ms(isFinished)
        let finalMs = {
          ...initialMs,
          is_put: true,
          link: `${initialMs.link}/${item?.id}`,
        }

        if (isFinished) {
          finalMs = {
            ...finalMs,
            valid: {
              employee_comment: 'required',
            },
            link: `study/student_test_result/${item?.id}`,
            onSubmitSuccess: onAfterFinishedTestUpdate,
          }
        }

        asideModalStore.activity(finalMs, {
          ...item,
          group: +props.gid,
          teacher: item?.teacher?.id,
          student: item?.student?.id,
        })
        break
      case 'delete':
        swal({
          title: `Вы действительно хотите удалить "${item.test}, ${item.student.full_name}" за  ${timeConverter(item.date, 'clean_data')} г.?`,
          text: 'Восстановить удаленные данные будет невозможно.',
          icon: 'warning',
          buttons: [
            localisationMaster('button_2', 'alert'),
            localisationMaster('button_1', 'alert'),
          ],
        }).then((okay) => {
          const apiCfg = {
            method: 'delete',
            link: `groups/interim_result_tests/${item.id}`,
          }
          superAxiosRequest(apiCfg).then(({ data }) => {
            setTestResults([...data?.interim, ...data?.test_results])
          })
        })
        break

      default:
        break
    }
  }

  const groupedStudents = useMemo(() => {
    const result = testResults?.reduce((groups, element) => {
      const studentId = element?.student?.id
      if (!groups[studentId]) {
        groups[studentId] = {
          student: { ...element.student },
          data: [],
        }
      }
      groups[studentId].data.push(element)
      return groups
    }, {})

    return Object.values(result).sort((a, b) => {
      const fullNameA =
        `${a?.student?.last_name} ${a?.student?.first_name}`.toLowerCase()
      const fullNameB =
        `${b?.student?.last_name} ${b?.student?.first_name}`.toLowerCase()
      return fullNameA.localeCompare(fullNameB)
    })
  }, [testResults])

  useEffect(() => {
    superAxiosRequest({
      method: 'get',
      link: `study/test_result_by_group/${props?.gid}`,
    })
      .then(({ data }) => {
        setTestResults([...data?.interim, ...data?.test_results])
      })
      .catch((error) => {
        console.error('Error fetching group:', error)
      })

    superAxiosRequest({
      method: 'get',
      link: 'study/study_category',
    })
      .then(({ data }) => {
        setCategories(data || [])
      })
      .catch((error) => {
        console.error('Error fetching categories:', error)
      })
  }, [props?.gid])

  return (
    <HeaderContentBox>
      <OpenHeader
        title={translate.tests}
        onClick={() => setOpen(!open)}
        link={`/groups/tests/${props?.gid}`}
        target={'_blank'}
        addButton={!Stores.isClient ? addTest : null}
        openIcon
      />
      {open && (
        <>
          {groupedStudents?.length > 0 ? (
            <div>
              {groupedStudents?.map((item, index) => {
                return (
                  <TestResult
                    item={item}
                    key={index}
                    menu={menu}
                    actions={actions}
                    translate={translate}
                    stats={null}
                  />
                )
              })}
            </div>
          ) : (
            <div className={style.empty}>
              <EmptyData />
            </div>
          )}
        </>
      )}
    </HeaderContentBox>
  )
}

TestResults.propTypes = {
  gid: PropTypes.number,
  tests: PropTypes.arrayOf(PropTypes.object),
}

export default observer(TestResults)
